import { render, staticRenderFns } from "./EditCustomerOrder.vue?vue&type=template&id=4a3104ea&scoped=true&"
import script from "./EditCustomerOrder.vue?vue&type=script&lang=js&"
export * from "./EditCustomerOrder.vue?vue&type=script&lang=js&"
import style0 from "./EditCustomerOrder.vue?vue&type=style&index=0&id=4a3104ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3104ea",
  null
  
)

export default component.exports